export const netbatchJobsInitialState = {
  currentSessionJobs: {},
  externalWindows: {},
  fetchedNbJobs: [],
  removedJobsIds: [],
};
